export default {
    update_slot: {
        original_appointment_time: 'Original appointment time:',
    },
    patient_seen: {
        is_patient_seen_modal: {
            heading: {
                appointment_with: 'Appointment with patient',
                was_scheduled_for: 'was scheduled for:',
            },
            was_patient_seen: 'Was patient seen?',
            buttons: {
                didnt_show: "DIDN'T SHOW",
                patient_seen: 'PATIENT SEEN',
                skip_all: 'SKIP ALL',
            },
        },
    },
    rate_referred: {
        rate_on_scale: 'Rate on a scale of 1-5, where 1 is "Not Happy" and 5 is excellent',
        ratings: {
            ancillary: {
                qualityOfTest: 'Quality of test ordered',
                qualityOfTheReport: 'Quality of the report (if any)',
                patientExperience: 'Patient experience /Feedback from patient',
                reportReceivedOnTime: 'Was the report received in a timely fashion?',
                overallSatisfaction: 'Overall satisfaction with referral',
            },
            physician: {
                professionalism: 'Professionalism',
                fundOfKnowledge: 'Fund of Knowledge',
                patientCare: 'Patient care /Feedback from patient',
                receiptOfConsultationNote: 'Timeliness of consultation note',
                overallSatisfaction: 'Overall satisfaction with referral',
            },
        },
        buttons: {
            back_to_referrals: 'BACK TO REFERRALS',
        },
        thank_you_for_rating: 'Thank you for rating {designation} {referredToName}',
    },
    ratings_enter: {
        buttons: {
            back: 'Back',
            next: 'NEXT',
            done: 'DONE',
        },
    },
    ratings_summary_modal: {
        buttons: {
            close: 'CLOSE',
        },
    },
    action_not_allowed: 'Action not implemented/supported!',
}
